import React, { useState } from "react";
import { Modal, Tabs } from "antd";
import { useTranslation } from "react-i18next";

import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";

import { IconEye, IconUpLoad } from "../../../../assets/icon";
import ModalPreviewPost from "../other/ModalPreviewPost";
import moment from "moment";
import { dealSelector } from "../../../../services/selector/index.";
import { checkNumber, validateUrl } from "../../../../utils/functionCommon";
import {
  createDeal,
  setOpenModalPostDeals,
} from "../../../../services/slice/DealSlice";
import BaseButton from "../../Button/BaseButton";
import TabDeals from "../../Tabs/TabDeals";
import TabAddChatBkavPro from "../../Tabs/TabAddChatBkavPro";

const ModalAddChatBkav = ({ title, postDeals }) => {
  const [datapost, setDataPost] = useState({
    title: "",
    descriptions: "",
    content: "",
    numberCustomer: 0,
    typePreferential: 0,
    typePost: 1,
    timeStart: "",
    timeEnd: "",
    attractGroup: "",
    displayRange: 0,
  });
  const dealState = useSelector(dealSelector);
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openPreview, setOpenPreview] = useState(false);
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const handleSave = () => {
    const firstTime = new Date(datapost.timeStart).getTime();
    const secondTime = new Date(datapost.timeEnd).getTime();

    if (
      !datapost.title ||
      datapost.content === "<p><br></p>" ||
      !datapost.content ||
      !datapost.descriptions ||
      !datapost.typePost ||
      !datapost.timeEnd ||
      !datapost.timeStart ||
      !image
    ) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    if (datapost.typePost === 2 && !validateUrl(datapost.content)) {
      setError({
        isError: true,
        msg: "Đường dẫn không hợp lệ",
      });
      return;
    }
    if (image.size > 2 * 1024 * 1024) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });
      return;
    }
    // if (image && !allowedFormats.includes(image.type)) {
    //   setError({
    //     isError: true,
    //     msg: "File có định dạng .jpeg, .png, .gif",
    //   });
    //   return;
    // }
    if (secondTime - firstTime <= 0) {
      setError({
        isError: true,
        msg: "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc",
      });
      return;
    }
    if (datapost.displayRange === 1 && !datapost.attractGroup.length) {
      setError({
        isError: true,
        msg: "Nhóm khách hàng nhận ưu đãi không xác định",
      });
      return;
    }
    if (
      datapost.displayRange === 1 &&
      datapost.numberCustomer &&
      (!checkNumber(datapost.numberCustomer) || datapost.numberCustomer < 0)
    ) {
      setError({
        isError: true,
        msg: "Bạn nhập sai định dạng. Vui lòng nhập lại",
      });
      return;
    }

    setError({
      isError: false,
      msg: "",
    });
    const formPost = new FormData();
    formPost.append("secondImage", datapost.secondImage);
    formPost.append("firstImage", datapost.firstImage);
    formPost.append("thirdImage", datapost.thirdImage);
    formPost.append(
      "content",
      datapost.content.replace(
        new RegExp(window.SERVER_URL, "g"),
        window.SERVER_CLIENT_URL
      )
    );
    formPost.append("title", datapost.title);
    formPost.append("numberCustomer", datapost.numberCustomer);
    if (datapost.attractGroup.length) {
      formPost.append("attractGroup", JSON.stringify(datapost.attractGroup));
    }
    formPost.append("descriptions", datapost.descriptions);
    formPost.append("displayRange", datapost.displayRange);
    formPost.append("timeStart", datapost.timeStart);
    formPost.append(
      "timeEnd",
      moment(datapost.timeEnd).format("YYYY-MM-DD HH:mm:ss")
    );
    formPost.append("typePreferential", datapost.typePreferential);
    formPost.append("typePost", datapost.typePost);
    dispatch(createDeal(formPost));
  };
  const handCancel = () => {
    dispatch(setOpenModalPostDeals(false));
  };

  const handleChangeTab = (key) => {
    setError({
      isError: false,
      msg: "",
    });
    if (key === "content") {
      setDataPost({
        ...datapost,
        content: "",
        typePost: 1,
      });
    } else
      setDataPost({
        ...datapost,
        content: "",
        typePost: 2,
      });
  };
  const handleClickPreview = () => {
    if (datapost.content && datapost.title) setOpenPreview(true);
    else return;
  };
  return (
    <>
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(title)}
        centered
        width={1300}
        open={dealState.isOpenModalPostDeals}
        // onOk={() => setOpen(false)}
        onCancel={handCancel}
        footer={[
          <BaseButton
            content={"Xem trước"}
            width={140}
            typeBtn="btnOrange"
            icon={<IconEye fill="white" />}
            handleClick={handleClickPreview}
          />,
          <BaseButton
            content={"Đăng bài viết"}
            typeBtn="btnOrange"
            icon={<IconUpLoad />}
            handleClick={handleSave}
          />,
        ]}
      >
        {openPreview && (
          <ModalPreviewPost
            open={openPreview}
            setOpen={setOpenPreview}
            data={datapost}
          />
        )}
        <TabAddChatBkavPro
          addPost={true}
          img={image}
          error={error}
          datapost={datapost}
          setDataPost={setDataPost}
          setImage={setImage}
        />
        {/* <Tabs
          onChange={handleChangeTab}
          defaultActiveKey="content"
          items={[
            {
              label: t("Viết bài"),
              key: "content",
              children: (
                <TabDeals
                  addPost={true}
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },

            {
              label: t("Nhập link"),
              key: "link",
              children: (
                <TabDeals
                  addPost={true}
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },
          ]}
        /> */}
      </Modal>
    </>
  );
};

export default ModalAddChatBkav;
